module.exports = __webpack_public_path__ + "static/media/logo_beta.0bd3d2c3.svg";